const Header = () => {
  return (
    <>
      <header className=" text-center text-5xl  text-white font-bold">
        My notes
      </header>
      <hr className=" self-center h-2 w-[100%] md:w-[80%] lg:w-[70%]" />
    </>
  );
};

export default Header;
